import { defineMessages } from '@transcend-io/internationalization';

export const selectAgentFilesMessages = defineMessages(
  'admin-dashboard.Pathfinder.components.SelectAgentFiles.selectAgentFiles',
  {
    placeholder: { defaultMessage: 'Select Files' },
  },
);
